import { booleanAttribute, Component, input } from '@angular/core';

import { ButtonToggleControlComponent } from '../button-toggle-control/button-toggle-control.component';
import { hintAlign, THintAlign, TToggleAppearance, toggleAppearance } from '../../models/form-field-options';
import { IToggleOption } from '../../models/toggle-option.model';
import { _ValueControlComponent } from '../../components/_value-control.component';

// Button-toggle zonder FormControl: [value]/(valueChange) met de itemId (of string) als waarde.
// Material zit in app-button-toggle-control.
@Component({
    selector: 'app-button-toggle',
    templateUrl: './button-toggle.component.html',
    standalone: true,
    imports: [
        ButtonToggleControlComponent,
    ],
})
export class ButtonToggleComponent
    extends _ValueControlComponent<string | number>
{
    input_appearance$$                   = input<TToggleAppearance>(toggleAppearance.standard, { alias: 'appearance' });
    input_framed$$                       = input(true,                                         { transform: booleanAttribute, alias: 'framed' });
    input_hideSingleSelectionIndicator$$ = input(false,                                        { transform: booleanAttribute, alias: 'hideSingleSelectionIndicator' });
    input_list$$                         = input<IToggleOption[] | string[]>([],               { alias: 'list' });
    input_vertical$$                     = input(false,                                        { transform: booleanAttribute, alias: 'vertical' });
    input_hint$$                         = input<string>('',                                   { alias: 'hint' });
    input_hintAlign$$                    = input<THintAlign>(hintAlign.start,                  { alias: 'hintAlign' });

    override out_valueChange = this._out_valueChange;

    override control$$  = this._control$$;
    override disabled$$ = this._input_disabled$$;
    override label$$    = this._input_label$$;
    override readonly$$ = this._input_readonly$$;
    override value$$    = this._input_value$$;

    emit_valueChange(value: string | number): void {
        super._emit_valueChange(value);
    }
}
